<template>
    <div class="dialog">
        <div class="title">{{tips.title}}</div>
        <div class="content" v-html="tips.content">
        </div>
    </div>
</template>
<script>
import { notices } from '../homePage/index.js'
export default{
    name: 'notice-tips',
    data() {
        return {
            tips: notices[this.$route.query.type]
        }
    }
}
</script>
<style lang="scss" scoped>
.dialog{
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 14px 33px 0px rgba(0, 0, 0, 0.11);
    // max-height: 80%;
    position: absolute;
    width: 1097px;
    height: calc(100% - 178px);
    top: 102px;
    left: 50%;
    transform: translatex(-50%);
    padding: 20px 0;
    box-sizing: border-box;
    overflow-y: auto;
    *{
        box-sizing: border-box;
    }
    .title{
        font-size: 22px;
        font-weight: 600;
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: rgba(0, 0, 0, 1);
        margin-top: 32px;
    }
    .content{
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        color: rgba(0, 0, 0, 1);
        margin-top: 24px;
        // overflow-y: scroll;
        // height: calc(100% - 88px);
        padding: 0 54px;
        /deep/ .tableEditBox{
            //width: 100% !important;
            //overflow: auto !important;
            //@include scrollstyle();
            // max-height: calc(100vh - 300px);
            font-size: 14px;
            text-align: justify;
            cursor: auto;
            padding-right: 3px;
            box-sizing: border-box;
            table{
              border: 1px solid;
              td, th{
                border-bottom: 1px solid #ccc;
                border-right: 1px solid #ccc;
                padding: 3px 5px;
              }
            }
        }
    }
}
</style>